module.exports = __webpack_public_path__ + "img/banner-basic.c585e277.png";